import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { connect } from 'react-redux';
import { getNCFileByPartId } from '@reducers/manufacture';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { getProductionBatchByPart, operationsSearch } from '@reducers/search';
import { usePartDetails } from '@v2/pages/common/hooks/usePartDetails';
import { getPartByID } from '@reducers/parts';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { NCFileSearchItem } from '@interfaces/search';
import Links from '@components/ncFiles/components/links';
import NcFileVersions from '@components/ncFileVersions';

interface PartDetailsNCFileVersionsProps {
  ncFileData: ReducerEntityWithLoadingState<NCFileSearchItem | null>;
}

const PartDetailsNCFileVersionsComponent: FC<PartDetailsNCFileVersionsProps> = ({
  getNCFileByPartId,
  clearTools,
  getTools,
  getProductionBatchByPart,
  updateHeaderConfig,
  getPartByID,
  operationsSearch,
  ncFileData,
}) => {
  const title = useTitle();

  usePartDetails({
    clearTools,
    getNCFileByPartId,
    getTools,
    getProductionBatchByPart,
    updateHeaderConfig,
    getPartByID,
    operationsSearch,
    getAllNcFiles: true,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <NcFileVersions ncFile={ncFileData.data} loaded={ncFileData.wasLoaded} />
    </DetailsPageWrapper>
  );
};

const PartDetailsNCFileVersions = connect(({ details: { ncFileData } }) => ({ ncFileData }), {
  getNCFileByPartId,
  clearTools,
  getTools,
  getProductionBatchByPart,
  updateHeaderConfig,
  getPartByID,
  operationsSearch,
})(PartDetailsNCFileVersionsComponent);

export { PartDetailsNCFileVersions };
